module.exports = __webpack_public_path__ + "img/eicon4.ffbd7ea5.png";